import { render, staticRenderFns } from "./defectCreateNode.vue?vue&type=template&id=5d2c7700&scoped=true&"
import script from "./defectCreateNode.vue?vue&type=script&lang=js&"
export * from "./defectCreateNode.vue?vue&type=script&lang=js&"
import style0 from "./defectCreateNode.vue?vue&type=style&index=0&id=5d2c7700&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c7700",
  null
  
)

export default component.exports